<template>
  <div class="content">
    <SingleCardLayout :urls="media" :title="title" />
    <card class="text-left">
      <div class="row">
        <label class="col-sm-2 col-form-label">컨텐트 ID</label>
        <div class="col-sm-10">
          <base-input>
            <p class="form-control-static">{{ contentId }} / {{ siteName }}</p>
          </base-input>
        </div>
      </div>
      <div class="row">
        <label class="col-sm-2 col-form-label">타이틀</label>
        <div class="col-sm-10">
          <base-input>
            <p class="form-control-static">{{ title }}</p>
          </base-input>
        </div>
      </div>
      <div class="row">
        <label class="col-sm-2 col-form-label">내용</label>
        <div class="col-sm-10">
          <base-input>
            <p class="form-control-static">{{ content }}</p>
          </base-input>
        </div>
      </div>
      <div class="row">
        <label class="col-sm-2 col-form-label">작성자</label>
        <div class="col-sm-10">
          <base-input>
            <p class="form-control-static">
              {{ authorName }} <span v-if="authorAccount">({{ authorAccount }})</span>
            </p>
          </base-input>
        </div>
      </div>
      <div class="row">
        <label class="col-sm-2 col-form-label">작성시간</label>
        <div class="col-sm-10">
          <base-input>
            <p class="form-control-static">
              {{ writtenTime | formatDateTime }}
            </p>
          </base-input>
        </div>
      </div>
      <div class="row">
        <label class="col-sm-2 col-form-label">수집시간</label>
        <div class="col-sm-10">
          <base-input>
            <p class="form-control-static">
              {{ regTime | formatDateTime }}
            </p>
          </base-input>
        </div>
      </div>
      <div class="row">
        <label class="col-sm-2 col-form-label">경로</label>
        <div class="col-sm-10">
          <base-input>
            <p class="form-control-static">
              <a @click="showLink(path)"> {{ path }}</a>
            </p>
          </base-input>
        </div>
      </div>
      <!--      <div class="row">-->
      <!--        <label class="col-sm-2 col-form-label">관련 아티스트</label>-->
      <!--        <div class="col-sm-10">-->
      <!--          <base-input>-->
      <!--            <p class="form-control-static">-->
      <!--              {{ memberNames.toString() }}-->
      <!--            </p>-->
      <!--          </base-input>-->
      <!--        </div>-->
      <!--      </div>-->
      <div class="row">
        <label class="col-sm-2 col-form-label">관련 아티스트</label>
        <div class="col-sm-6">
          <el-select multiple class="select-primary" size="large" placeholder="멤버선택" v-model="members.members">
            <el-option v-for="option in members.options" class="select-primary" :value="option.value" :label="option.label" :key="option.label"></el-option>
          </el-select>
          <el-popover trigger="hover" placement="top">
            <div>
              <div class="popover-body">
                그룹, 멤버 각각 설정한대로 필터에 노출됩니다. <br />
                최소 하나 이상 선택해야합니다.
              </div>
            </div>
            <base-button slot="reference"> ? </base-button>
          </el-popover>
        </div>
        <div class="col-sm-4">
          <base-button class="footer-buttons col-6" @click="setRadarArtists" type="success">저장</base-button>
        </div>
      </div>
      <div class="row">
        <label class="col-sm-2 col-form-label">조회수</label>
        <div class="col-sm-10">
          <base-input>
            <p class="form-control-static">{{ viewCount }}</p>
          </base-input>
        </div>
      </div>
      <div class="row">
        <label class="col-sm-2 col-form-label">댓글수</label>
        <div class="col-sm-10">
          <base-input>
            <p class="form-control-static">{{ commentCount }}</p>
          </base-input>
        </div>
      </div>
      <div class="row">
        <label class="col-sm-2 col-form-label">좋아요수</label>
        <div class="col-sm-10">
          <base-input>
            <p class="form-control-static">{{ likeCount }}</p>
          </base-input>
        </div>
      </div>
      <div class="row">
        <label class="col-sm-2 col-form-label">저장수</label>
        <div class="col-sm-10">
          <base-input>
            <p class="form-control-static">{{ pinCount }}</p>
          </base-input>
        </div>
      </div>
      <!--      <div class="row">-->
      <!--        <label class="col-sm-2 col-form-label">멤버</label>-->
      <!--        <div class="col-sm-4">-->
      <!--          <el-select multiple class="select-primary" size="large" placeholder="멤버선택" v-model="members.members">-->
      <!--            <el-option v-for="option in members.options" class="select-primary" :value="option.value" :label="option.label" :key="option.label"></el-option>-->
      <!--          </el-select>-->
      <!--        </div>-->
      <!--        <div class="col-sm-4">-->
      <!--          <base-button class="footer-buttons col-6" @click="setCollectionMembers" type="success">저장</base-button>-->
      <!--        </div>-->
      <!--      </div>-->
    </card>
    <div class="row actions">
      <div v-if="isVisible !== 0" class="col-md-4">
        <base-button class="btn-danger col-md-12" @click="hideContent" type="success">숨김</base-button>
      </div>
      <div v-if="isVisible !== 1" class="col-md-4">
        <base-button class="footer-buttons col-md-12" @click="showContent" type="success">표시</base-button>
      </div>
      <div class="col-md-4">
        <base-button class="footer-buttons col-md-12" @click="showModal" type="success">띄워주자</base-button>
      </div>
      <div class="col-md-4"><base-button class="footer-buttons col-md-12" @click="onClickComments" type="success">댓글 조회</base-button></div>
    </div>
    <div class="pick-section">
      <h4 class="section-title pull-left">노출 내역</h4>
      <card>
        <div class="col-md-12">
          <el-table :data="showHistory">
            <el-table-column v-for="column in showHistoryColumns" :key="column.label" :min-width="column.minWidth" :prop="column.prop" :label="column.label" />
          </el-table>
        </div>
      </card>
    </div>

    <div class="pick-section">
      <h4 class="section-title pull-left">신고 내역</h4>
      <card>
        <div class="row">
          <ReportsForContentTableView class="col-12" :reports="reports" />
        </div>
      </card>
    </div>
    <RadarContentDetailModal
      :key="componentKey"
      :contentId="contentId"
      :unitId="unitId"
      :members="memberIds"
      :shouldShow="contentModal.show"
      :onConfirm="onContentModal"
      :onCancel="onCancelModal"
    />
  </div>
</template>
<script>
import { Card, BaseInput } from "@/components/index";
import SingleCardLayout from "@/pages/Components/SingleCardLayout.vue";
import RadarContentDetailModal from "./RadarContentDetailModal.vue";
import ReportsForContentTableView from "@/pages/Reports/ReportsForContentTableView";
import { showAPIErrorToast } from "@/util/ErrorUtils";
import swal from "sweetalert2";
import { BlipNamespace } from "@/common/BlipNamespace";
import { formatDateTime } from "@/util/DateUtils";

export default {
  components: {
    BaseInput,
    Card,
    SingleCardLayout,
    RadarContentDetailModal,
    ReportsForContentTableView,
  },
  async created() {
    if (!this.$route.query.unitId || !this.$route.query.contentId) {
      window.Toast.error("잘못된접근입니다");
      history.go(-1);
      return;
    }

    this.unitId = Number(this.$route.query.unitId);
    this.contentId = Number(this.$route.query.contentId);
    await this.getArtistUnits();
    await this.getArtistMembers();
    await this.getRadarContentDetail();
    await this.getReports();
  },
  data() {
    return {
      componentKey: 0,
      title: null,
      media: [],
      contentId: null,
      authorName: null,
      authorAccount: null,
      siteName: null,
      path: null,
      isVisible: null,
      content: null,
      state: null,
      likeCount: 0,
      viewCount: 0,
      commentCount: 0,
      pinCount: 0,
      regTime: null,
      writtenTime: null,
      reports: [],
      members: {
        members: [],
        options: [],
      },
      memberIds: [],
      memberNames: [],
      contentModal: {
        show: false,
      },
      showHistoryColumns: [
        {
          prop: "type",
          label: "구분",
          minWidth: 50,
        },
        {
          prop: "startTime",
          label: "시작시간",
          minWidth: 150,
        },
        {
          prop: "endTime",
          label: "종료시간",
          minWidth: 150,
        },
        {
          prop: "result",
          label: "처리내용",
          minWidth: 120,
        },
        {
          prop: "adminId",
          label: "운영자ID",
          minWidth: 120,
        },
      ],
      showHistory: [],
    };
  },
  methods: {
    async getRadarContentDetail() {
      return this.$axios.get(`/radarContent/${this.contentId}`).then((res) => {
        const data = res.data.data;
        console.log(data);
        this.title = data.title;
        this.media = data.media;
        this.siteName = data.siteName;
        this.content = data.content;
        this.authorName = data.authorName;
        this.authorAccount = data.authorAccount;
        this.contentId = data.contentId;
        this.path = data.path;
        this.isVisible = data.isVisible;

        this.state = data.state;

        this.likeCount = data.likeCount;
        this.viewCount = data.viewCount;
        this.commentCount = data.commentCount;
        this.pinCount = data.pinCount;
        this.regTime = data.regTime;
        this.writtenTime = data.writtenTime;
        const artists = data.artists.split("[[BLIP_SEP]]");
        artists.forEach((items) => {
          const item = items.split("|");
          this.memberIds.push(Number(item[0]));
          this.memberNames.push(item[1]);
        });
        this.members.members = this.memberIds;
      });
    },
    async getArtistUnits() {
      return this.$axios.get(`/artistUnit/${this.unitId}`, null).then((res) => {
        const data = res.data.data;
        this.members.options.push({ label: data.blipName, value: data.artistId });
      });
    },
    async getArtistMembers() {
      return this.$axios.get(`/artistUnit/${this.unitId}/members`, null).then((res) => {
        const data = res.data.data;
        // this.members.options.push({ label: "전체", value: "" });
        if (data.length > 0) {
          data.forEach((item) => {
            const option = {};
            option.label = item.blipName ? item.blipName : item.name;
            option.value = item.artistId;
            this.members.options.push(option);
          });
        }
      });
    },

    showLink(link) {
      window.open(link);
    },
    async getReports() {
      try {
        const result = await this.$axios.get(`/radarContent/${this.contentId}/reports`);
        this.reports = result.data.data;
      } catch (err) {
        showAPIErrorToast(err);
      }
    },

    async hideContent() {
      swal
        .fire({
          title: "숨김 확인",
          text: `${this.contentId} 컨텐트를 숨김하시겠습니까?`,
          type: "warning",
          showCancelButton: true,
          confirmButtonClass: "btn btn-danger btn-fill",
          cancelButtonClass: "btn btn-cancel btn-fill",
          confirmButtonText: "숨김",
          cancelButtonText: "취소",
          buttonsStyling: false,
        })
        .then(async (selection) => {
          if (selection.value) {
            try {
              return this.$axios
                .put(`/radarContent/${this.contentId}/state`, {
                  params: { unitId: this.unitId, isVisible: 0 },
                })
                .then(() => {
                  window.Toast.success("컨텐트가 숨김 되었습니다");
                  this.isVisible = 0;
                });
            } catch (err) {
              window.Toast.error("컨텐트 숨김 중 에러가 발생하였습니다.");
            }
          }
        });
    },
    async showContent() {
      swal
        .fire({
          title: "표시 확인",
          text: `${this.contentId} 컨텐트를 표시하시겠습니까?`,
          type: "warning",
          showCancelButton: true,
          confirmButtonClass: "btn btn-danger btn-fill",
          cancelButtonClass: "btn btn-cancel btn-fill",
          confirmButtonText: "표시",
          cancelButtonText: "취소",
          buttonsStyling: false,
        })
        .then(async (selection) => {
          if (selection.value) {
            try {
              return this.$axios
                .put(`/radarContent/${this.contentId}/state`, {
                  params: { unitId: this.unitId, isVisible: 1 },
                })
                .then(() => {
                  window.Toast.success("컨텐트가 표시 되었습니다");
                  this.isVisible = 1;
                });
            } catch (err) {
              window.Toast.error("컨텐트 표시 중 에러가 발생하였습니다.");
            }
          }
        });
    },

    async setRadarArtists() {
      if (this.members.members.length === 0) {
        window.Toast.error("적어도 한명 이상의 아티스트를 선택해야 합니다");
        return;
      }
      return this.$axios.put(`/radarContent/${this.contentId}/artists`, { param: { artists: this.members.members } }).then((res) => {
        window.Toast.success("관련 아티스트가 설정되었습니다");
      });
    },
    showModal() {
      this.contentModal.show = true;
    },
    onClickComments() {
      this.$router.push(`/comment/all?namespace=${BlipNamespace.RADAR}&unitId=${this.unitId}&contentId=${this.contentId}`);
    },
    onContentModal() {},
    onCancelModal() {
      this.contentModal.show = false;
    },
  },
};
</script>
<style scoped lang="scss">
.actions {
  margin-bottom: 40px;
}
</style>
